<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model.trim="listQuery.productname"
        clearable
        placeholder="品名"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 150px;"
      ></el-input>

      <el-input
        v-model.trim="listQuery.factory"
        clearable
        placeholder="厂家"
        class="filter-item"
        @keyup.enter.native="getList"
        style="margin-right: 10px;width: 150px;"
      ></el-input>

      <!--
      <el-checkbox-group v-model="listQuery.dirfrom" style="display:inline">
        <el-checkbox label="直接挂网"></el-checkbox>
        <el-checkbox label="带量采购"></el-checkbox>
        <el-checkbox label="联动目录"></el-checkbox>
        <el-checkbox label="备选目录"></el-checkbox>
        <el-checkbox label="备案采购"></el-checkbox>
        <el-checkbox label="应急药品"></el-checkbox>
        <el-checkbox label="急抢救"></el-checkbox>
        <el-checkbox label="专区目录"></el-checkbox>
      </el-checkbox-group>

      <el-checkbox-group v-model="listQuery.dirproperty" style="display:inline;margin-left:15px;">
        <el-checkbox label="非基本药物"></el-checkbox>
        <el-checkbox label="基本药物"></el-checkbox>
      </el-checkbox-group>

      <el-checkbox-group v-model="listQuery.ybtype" style="display:inline;margin-left:15px;">
        <el-checkbox label="医保甲类"></el-checkbox>
        <el-checkbox label="医保乙类"></el-checkbox>
        <el-checkbox label="无"></el-checkbox>
      </el-checkbox-group>

      <el-checkbox v-model="addform.consistency" style="margin-left:15px;" label="一致性"></el-checkbox>
      <el-checkbox v-model="addform.jiming" label="济明代理"></el-checkbox>
      <el-checkbox v-model="addform.lpz" style="margin-right:15px;" label="两票制"></el-checkbox>-->

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit" @click="handleCreate">新增</el-button>
      
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      ref="dataTable"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
       :max-height="clientHeight" 
      size="mini"
    >
      <!--<el-table-column align="center" label="ID" width="100">
        <template slot-scope="scope">{{ scope.row.id }}</template>
      </el-table-column>-->
      <el-table-column label="操作" align="center" width="168px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">
            <i class="el-icon-edit"></i>修改
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">
            <i class="el-icon-delete"></i>删除
          </el-button>
        </template>
      </el-table-column>

      <el-table-column align="center" label="编码" width="80">
        <template slot-scope="scope">{{ scope.row.procode }}</template>
      </el-table-column>
      <el-table-column align="center" label="品名" width="140">
        <template slot-scope="scope">{{ scope.row.productname }}</template>
      </el-table-column>
      <el-table-column label="规格" align="center" width="90" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.spec }}</template>
      </el-table-column>
      <el-table-column label="剂型" align="center" width="70" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.drug }}</template>
      </el-table-column>
      <el-table-column label="厂家" align="center" width="120" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.factory }}</template>
      </el-table-column>
      <el-table-column label="单位" align="center" width="70" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.unit }}</template>
      </el-table-column>
      <el-table-column label="批准文号" align="center" width="70" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.approvalno }}</template>
      </el-table-column>
      <el-table-column label="中标价" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.bidprice }}</template>
      </el-table-column>
      <el-table-column label="目录来源" align="center" width="90" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ scope.row.dirfrom }}</template>
      </el-table-column>
      <el-table-column label="目录属性" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.dirproperty }}</template>
      </el-table-column>
      <el-table-column label="医保类型" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.ybtype }}</template>
      </el-table-column>
      <el-table-column label="通过一致性评价" align="center" width="100">
        <template slot-scope="scope">{{ scope.row.consistency }}</template>
      </el-table-column>
      <el-table-column label="济明代理" align="center" width="80">
        <template slot-scope="scope">{{ scope.row.jiming }}</template>
      </el-table-column>
      <el-table-column label="产品特点" align="center" width="200">
        <template slot-scope="scope">{{ scope.row.remark }}</template>
      </el-table-column>
      <el-table-column label="推广科室" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.room }}</template>
      </el-table-column>
      <el-table-column label="执行两票制" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.lpz }}</template>
      </el-table-column>
      <el-table-column label="业务联系人" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.buzcontact }}</template>
      </el-table-column>
      <el-table-column label="电话" align="center" width="90">
        <template slot-scope="scope">{{ scope.row.tel }}</template>
      </el-table-column>
      
    </el-table>

    <el-dialog customClass="customWidth"

        :modal="true" 

        :visible.sync="ImportdialogVisible"

         width="29%"

        :title="ImportTitle"    

     >

     

      <el-form :model="form">

        <el-form-item>

          <el-upload class="upload-file"

            drag

            ref="uploadExcel"

            action="http://222.240.174.182:9099/api/productinfo/flowimport"

            :limit=limitNum

            :auto-upload="false"

            accept=".xlsx"

            :before-upload="beforeUploadFile"

            :on-change="fileChange"

            :on-exceed="exceedFile"

            :on-success="handleSuccess"

            :on-error="handleError"

            :file-list="fileList"

          >

          <i class="el-icon-upload"></i>

          <div class="el-upload__text">将文件拖到此处，或<em>点击选择Excel文件</em></div>

          <!-- <div slot="tip" class="el-upload-list__item-name">{{fileName}}</div> -->

          </el-upload>

      </el-form-item>

      <el-form-item>

          <div style="margin-left: 120px;">

            <el-button @click="ImportdialogVisible = false" size="small">取 消</el-button>

            <el-button size="small" type="primary" @click="submitUpload()">立即导入</el-button>

          </div>

      </el-form-item>

    </el-form> 

  </el-dialog>

  <el-dialog customClass="customWidth"

        :modal="true" 

        :visible.sync="AdddialogVisible"

         width="70%"

        title="新增明细"    

     >
     <el-form :model="form" label-width="100px">
      <el-row>
        <el-col span="8">
          <el-form-item label="平台交易编码">
              <el-input v-model="addform.procode" placeholder="请输入平台交易编码" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="品名">
              <el-input v-model="addform.productname" placeholder="请输入品名全称" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="规格">
              <el-input v-model="addform.spec"  placeholder="请输入规格" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
       <el-col span="8">
          <el-form-item label="剂型">
              <el-input v-model="addform.drug"  placeholder="请输入剂型" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="厂家">
              <el-input v-model="addform.factory"  placeholder="请输入厂家全称" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="单位">
              <el-input v-model="addform.unit"  placeholder="请输入单位例如：瓶/支/盒/..." style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col span="8">
          <el-form-item label="批准文号">
              <el-input v-model="addform.approvalno"  placeholder="请输入批准文号" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

       <el-col span="8">
          <el-form-item label="中标价">
              <el-input v-model="addform.bidprice" type="number" placeholder="请输入中标价" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="目录来源">
              <el-select
                v-model="addform.dirfrom"
                placeholder="请选择目录来源"
                class="filter-item"
                collapse-tags
                style="margin-right: 10px;width:100%"
              >
                <el-option
                  v-for="item in dirfromlist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

      </el-row>

      <el-row>
        <el-col span="3">
          <el-form-item label="通过一致性评价" label-width="120px">
              <el-checkbox v-model="addform.consistency"></el-checkbox>
          </el-form-item>
        </el-col>

        <el-col span="2">
          <el-form-item label="济明代理" >
              <el-checkbox v-model="addform.jiming"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col span="3">
          <el-form-item label="执行两票制" label-width="120px">
              <el-checkbox v-model="addform.lpz"></el-checkbox>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="目录属性">
              <el-select
                v-model="addform.dirproperty"
                placeholder="请选择目录属性"
                class="filter-item"
                collapse-tags
                style="margin-right: 10px;width:100%"
              >
                <el-option
                  v-for="item in dirpropertylist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="医保类型">
              <el-select
                v-model="addform.ybtype"
                placeholder="请选择医保类型"
                class="filter-item"
                collapse-tags
                @change="selectChanged"
                id="ybselect"
                :style="{'margin-right': '10px','width':ybwith}"
              >
                <el-option
                  v-for="item in ybtypelist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            
              <el-input v-model="addform.zfbl" v-if="showzfbl" placeholder="输入自付比例" style="width: 50%;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col span="8">
          <el-form-item label="产品特点">
              <el-input v-model="addform.remark"   placeholder="请输入产品特点(限制50字))" maxlength="50" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="适用科室">
              <el-input v-model="addform.room"  placeholder="请输入适用科室" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="业务联系人">
              <el-input v-model="addform.buzcontact"  placeholder="请输入业务联系人" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

      </el-row>

      <el-row>
        <el-col span="8">
          <el-form-item label="电话">
              <el-input v-model="addform.tel"  placeholder="电话" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col span="8">
          <el-form-item label="产品图片">

              <el-upload class="upload-file"
                ref="uploadExcel"
                action="http://222.240.174.182:9099/api/productadd/uploadimg"
                :limit=limitNum
                :auto-upload="false"
                accept="image/jpeg,image/gif,image/png"
                :before-upload="beforeUploadFile"
                :on-change="fileChange"
                :on-exceed="exceedFile"
                :on-success="handleSuccess"
                :on-error="handleError"
                :file-list="fileList"
              >
              <el-button slot="trigger" size="small" type="primary">选取</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
              </el-upload>
          </el-form-item>
        </el-col>

      </el-row>

      <el-row>
        <el-col span="24">
          <el-form-item>

              <div style="text-align:right">

                <el-button @click="AdddialogVisible = false" size="small">取 消</el-button>

                <el-button size="small" type="primary" @click="submitAdd()">保存</el-button>

              </div>

          </el-form-item>
        </el-col>

      </el-row>
      
    </el-form> 
  </el-dialog>

     <!--分页-->
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    >
    </pagination>
  </div>
</template>

<script>
import { selectProductList,saveProduct,deleteProduct } from '@/api/flow'
import Pagination from '@/components/Pagination'

export default {
  name: 'ProductInfo',

   components: {
     Pagination
   },

  data() {
    return {
      ybwith:'100%',
      showzfbl:false,
      clientHeight: '800',
      queryDate: [],
      list: null,
       total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        asc: false,
        startDate:'',
        endDate:'',
        productname:'',
        dirfrom:[],
        dirproperty:[],
        ybtype:[],
        consistency:'',
        jiming:'',
        lpz:''
      },
      code: '',
      artid: '',
      listLoading: false,
      downloadLoading: false,
      ImportdialogVisible:false, //"导入"对话框是否可见
      AdddialogVisible:false,
      ImportTitle:'导入Excel', //"导入"对话框的标题
      limitNum: 1,//导入文件的个数
      form: {    //"导入"表单绑定file，并初始化
          file: ''
        },
      addform:{
        id:'',
        procode:'',
        productname:'',
        spec:'',
        drug:'',
        factory:'',
        unit:'',
        bidprice:'',
        dirfrom:'',
        dirproperty:'',
        ybtype:'',
        consistency:'',
        jiming:'',
        remark:'',
        room:'',
        lpz:'',
        picpath:'',
        approvalno:'',
        buzcontact:'',
        tel:'',
        zfbl:''
      },
     dirfromlist: [{
          id: '直接挂网',
          name: '直接挂网'
        }, {
          id: '带量采购',
          name: '带量采购'
        },{
          id: '联动目录',
          name: '联动目录'
        },{
          id: '备案采购',
          name: '备案采购'
        },{
          id: '应急药品',
          name: '应急药品'
        },{
          id: '急抢救和短缺药品目录',
          name: '急抢救和短缺药品目录'
        },{
          id: '专区目录',
          name: '专区目录'
        }],
      dirpropertylist: [{
          id: '非基本药物',
          name: '非基本药物'
        }, {
          id: '《国家基本药物目录》（2018年版）品种',
          value: '《国家基本药物目录》（2018年版）品种'
        }],
      ybtypelist: [{
          id: '医保甲类',
          name: '医保甲类'
        }, {
          id: '医保乙类',
          value: '医保乙类'
        },{
          id: '无',
          value: '无'
        }],
      fileList: []//"导入"文件列表
    }
  },

  created() {
    this.getList();
    this.initHeight()
  },

  mounted() {
    window.addEventListener('resize', this.initHeight)
  },

  methods: {
    initHeight() {
      this.clientHeight = document.documentElement.clientHeight - 240
    },
    
    handleSelect(item) {
        this.addform.custid=item.id;
    },
    selectChanged(value) {
       if(value=='医保乙类'){
          this.ybwith = '45%';
          this.showzfbl = true;
       }else{
          this.ybwith = '100%';
          this.showzfbl = false;
       }
    },
    submitAdd(){
      if(this.addform.artid==''){
          this.$notify.warning({

            title: '提示',

            message: `请选择商品`

          });
          return;
      }
      
       let self = this;
        saveProduct(this.addform)
          .then(response => {
              this.$notify.success({

              title: '成功',

              message: `保存成功`

              });

              this.getList();

              self.AdddialogVisible = false; 
               this.addform={
                  id:'',
                  procode:'',
                  productname:'',
                  spec:'',
                  drug:'',
                  factory:'',
                  unit:'',
                  bidprice:'',
                  dirfrom:'',
                  dirproperty:'',
                  ybtype:'',
                  consistency:'',
                  jiming:'',
                  remark:'',
                  room:'',
                  lpz:'',
                  picpath:'',
                  buzcontact:'',
                  tel:'',
                  approvalno:'',
                  zfbl:''
                };
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
    },
    handleDelete(id) {
      this.$confirm('是否确认删除该条记录?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteFlow(id).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        })
        .catch(() => {})
    },
    getList() {
      this.list = []
      let [start, end] = this.queryDate || []
      this.listQuery.startDate = start
      this.listQuery.endDate = end
        this.listLoading = true
        selectProductList(this.listQuery)
          .then(response => {
            this.list = response.data.items
            this.total = response.data.total
            this.listLoading = false
            this.listLoading = false
          })
          .catch(() => {
            this.list = []
            this.listLoading = false
          })
      
    },
    // 新增按钮跳转到新增采购单
    handleCreate() {
      this.AdddialogVisible = true;
    },
    handleUpdate(obj) {
      this.AdddialogVisible = true;
      this.addform = obj;
      if(obj.consistency == '是'){
        this.addform.consistency = true;
      }
      if(obj.jiming == '是'){
        this.addform.jiming = true;
      }
      if(obj.lpz == '是'){
        this.addform.lpz = true;
      }
    },
    importBook(){ //弹出导入对话框

      let self = this;

      self.ImportdialogVisible = true;

    },

    // 文件超出个数限制时的钩子

    exceedFile(files, fileList) {

          this.$notify.warning({

          title: '警告',

          message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`

      });

    },

    // 文件状态改变时的钩子

    fileChange(file, fileList) {

        console.log('change')

        console.log(file)

        this.form.file = file.raw

        console.log(this.form.file)

        console.log(fileList)

      },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传

    beforeUploadFile(file) {

        console.log('before upload')

        console.log(file)

      // let extension = file.name.substring(file.name.lastIndexOf('.')+1); //获取上传文件的扩展名

        //console.log("文件扩展名为:"+extension);

        const isIMAGE = file.type === 'image/jpeg'||'image/gif'||'image/png';
        const isLt1M = file.size / 1024 / 1024 < 1;

        if (!isIMAGE) {
          this.$message.error('上传文件只能是图片格式!');
        }
        if (!isLt1M) {
          this.$message.error('上传文件大小不能超过 1MB!');
        }
        return isIMAGE && isLt1M;
      },

      // 文件上传成功时的钩子

      handleSuccess(res, file, fileList) {
          this.addform.picpath = res.data;
          debugger;
          let self = this;

          this.$notify.success({

          title: '成功',

          message: `图片上传成功`

          });

      },

      // 文件上传失败时的钩子

      handleError(err, file, fileList) {

          this.$notify.error({

          title: '错误',

          message: `文件上传失败`

          });

      },

      submitUpload(){

          let self = this;

          if(self.form.file == ''){

            this.$notify.error({

              title: '错误',

              message: `请选择要上传的图片`

            });

            return;

          }

          self.$refs.uploadExcel.submit();

      },
    // 格式化数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j]
        })
      )
    }
   }
}
</script>
<style rel="stylesheet/scss" lang="scss">
  // 3.修改表格边框颜色
  // 右边和下边
  .el-table--border:after,
  .el-table--group:after,
  .el-table:before {
    background-color: #42b983 !important;
  }
  // 左边和上边
  .el-table--border,
  .el-table--group {
    border-color: #42b983 !important;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #42b983 !important;
  }
  // 头部的下边框
  .el-table--border th,
  .el-table--border th.gutter:last-of-type {
    border-bottom: 1px solid #42b983 !important;
  }
  // 列表中间的竖线
  .el-table--border td,
  .el-table--border th {
    border-right: 1px solid #42b983 !important;
  }
</style>
